import { useCallback, useMemo, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { toast } from 'react-toastify'

import { SubmitBrazilEvent } from 'services/brazilEvent'
import { exposeStrapiError } from 'utils'
import { optionsCountries } from 'utils/options'

const interestOptions = [
    { id: '', title: 'Selecione um interesse (opcional)' },
    { id: 'Price', title: 'Preço' },
    { id: 'Product Information', title: 'Informações sobre produtos' },
    { id: 'Company Information', title: 'Informações sobre a empresa' },
    { id: 'TMS Information', title: 'Informações sobre TMS' },
    { id: 'Other', title: 'Outro' },
]

export default function useController() {
    const history = useHistory()
    const formRef = useRef()
    const [loading, setLoading] = useState(false)
    const [newsletterOptIn, setNewsletterOptIn] = useState(false)
    const [privacyPolicyOptIn, setPrivacyPolicyOptIn] = useState(false)
    const [success, setSuccess] = useState(false)

    const formItems = useMemo(() => [
        { ref: 'firstName', placeholder: 'Nome', half: true, required: true },
        { ref: 'lastName', placeholder: 'Sobrenome', half: true, required: true },
        { ref: 'email', placeholder: 'E-mail profissional', half: true, required: true },
        { ref: 'whatsapp', placeholder: 'WhatsApp', type: 'phone', half: true, required: true },
        { ref: 'company', placeholder: 'Empresa', half: true },
        {
            ref: 'country',
            placeholder: 'País',
            options: optionsCountries.map((country) => ({ id: country.title, title: country.title })),
            half: true,
            required: true,
        },
        { ref: 'state', placeholder: 'Estado', half: true, required: true },
        { ref: 'interest', placeholder: 'Interesse', options: interestOptions, half: true },
        { ref: 'message', placeholder: 'Mensagem', type: 'textarea', full: true },
    ], [])

    const submit = useCallback(async () => {
        if (loading) return

        const form = formRef.current?.getForm()
        if (!form) return

        if (!privacyPolicyOptIn) {
            toast.error('Para continuar, aceite a Política de Privacidade.')
            return
        }
        setLoading(true)
        try {
            const result = await SubmitBrazilEvent({
                ...form,
                newsletterOptIn,
                privacyPolicyOptIn,
            })

            if (!exposeStrapiError(result) && result?.liteStatus === 'success') {
                setSuccess(true)
            } else if (!result?.error) {
                toast.error('Não foi possível concluir sua inscrição. Tente novamente mais tarde.')
            }
        } finally {
            setLoading(false)
        }
    }, [loading, newsletterOptIn, privacyPolicyOptIn])

    const openLiteLogin = useCallback(() => {
        history.push('/mvu-lite/login')
    }, [history])

    return {
        formItems,
        formRef,
        loading,
        newsletterOptIn,
        privacyPolicyOptIn,
        success,
        setNewsletterOptIn,
        setPrivacyPolicyOptIn,
        submit,
        openLiteLogin,
    }
}
